import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { CreateTemplateRequestModel, DeleteTemplateRequestModel } from '@core/models/request/template.model';
import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.template.controller + API_ENDPOINT.template.getAll,
    );
  }

  getTemplateDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.template.controller + id,
    );
  }

  createTemplate(data: CreateTemplateRequestModel) {
    return this.http.post(
      API_ENDPOINT.template.controller,
      data,
    );
  }

  updateTemplate(data: CreateTemplateRequestModel, id: number) {
    return this.http.put(
      API_ENDPOINT.template.controller + id,
      data,
    );
  }

  deleteTemplate(id: number) {
    return this.http.delete(
      API_ENDPOINT.template.controller + id);
  }
}
